import React from 'react';
import './App.css';
import AuthProvider from './auth/AuthProvider.jsx';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NotificationApp from './notification/NotificationApp.jsx';

function App() {
  const routerBasename = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : undefined;

  return (
    <BrowserRouter basename={routerBasename}>
      <AuthProvider>
        <Routes>
          <Route path="*" element={<NotificationApp />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
